import { render, staticRenderFns } from "./ExerciseEdit.vue?vue&type=template&id=8808486e&scoped=true&"
import script from "./ExerciseEdit.vue?vue&type=script&lang=js&"
export * from "./ExerciseEdit.vue?vue&type=script&lang=js&"
import style0 from "./ExerciseEdit.vue?vue&type=style&index=0&id=8808486e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8808486e",
  null
  
)

export default component.exports